import React from 'react';
import { Box, BoxProps } from '@mui/material';
import { Download as DownloadIcon } from '@x5-react-uikit/icons';
import { Export as ExportIcon } from '@x5-react-uikit/icons';
import { Tooltip } from '@x5-react-uikit/core';

interface Props extends BoxProps {
  onUploadClick?: (id: string, payload?) => void;
  clientId: string;
  fileId: string;
  labelDownload?: string;
  labelUpload?: string;
  showUpload?: boolean;
  showDownload?: boolean;
}

const DownloadToolbar: React.FC<Props> = ({
  onUploadClick = () => {},
  clientId,
  fileId,
  labelDownload,
  labelUpload,
  showDownload,
  showUpload,
}) => {
  return (
    <>
      <Box display="flex" columnGap={2}>
        {showDownload && (
          <Tooltip placement="top" content={labelDownload}>
            <Box
              component="a"
              href={`/api/client-lists/${clientId}/files/${fileId}`}
              color="grey.70"
              download={true}
            >
              <DownloadIcon />
            </Box>
          </Tooltip>
        )}
        {showUpload && (
          <Tooltip placement="top" content={labelUpload}>
            <Box onClick={() => onUploadClick(clientId)} color="grey.70">
              <ExportIcon />
            </Box>
          </Tooltip>
        )}
      </Box>
    </>
  );
};

export default DownloadToolbar;
